import {makeStyles} from '@material-ui/core/styles';


const styleHeader = makeStyles({
  header:{
    textAlign:'center',
    fontFamily:['Black Ops One','cursive'],
  },
  title:{
    textShadow:'3px 5px 2px #9c9c9c',
    fontSize:60,
    margin:0,
    padding:0,
  },
  subTitle:{
    fontSize:25,
    margin:0,
    padding:0,
  },
});
export default styleHeader;